<template>
  <div class="header-container" :class="{'top-header-container-remove-radius' : contentPosition === -250}">
    <div class="mobile-header-icon" v-if="$store.state.appConfig.windowWidth < 769">
      <MobileHeaderIcon />
    </div>
    <div class="top-header-container">
      <BackButton :clickMethod="back" class="mb-3"/>
      <h4>
        {{$tI('Closest Populations')}}
        <span @click="ClosestPopulationsInfoModal.showModal = true" class="open-info-modal-btn">
          <InfoIcon />
        </span>
      </h4>
      <p class="description">
        {{ description }}
      </p>
    </div>

    <ClosestPopulationInfoModal v-if="ClosestPopulationsInfoModal.showModal" :modalObject="ClosestPopulationsInfoModal"/>
  </div>

</template>

<script>
import MobileHeaderIcon from '@/components/icons/MobileHeaderIcon.vue';
import BackButton from '@/components/ui/BackButton.vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import ClosestPopulationInfoModal from './modals/ClosestPopulationInfoModal.vue';

export default {
  components: {
    MobileHeaderIcon,
    BackButton,
    InfoIcon,
    ClosestPopulationInfoModal,
  },
  props: {
    contentPosition: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      ClosestPopulationsInfoModal: {
        showModal: false,
      },

      description: this.$tI_G('Closest Populations Subtitle'),

      underlineStyle: {
        width: '0px',
        left: '0px',
        backgroundColor: '#BB4ECE',
      }
    };
  },
  methods: {
    back() {
      this.$router.push({ name: 'dashboard' });
    },
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  background-color: var(--white-100);
  .mobile-header-icon {
    margin-bottom: -28px;
    margin-top: 0;
  }
}

.top-header-container {
  padding: 28px 28px 28px 28px;
}

@media screen and (max-width: 769px) {
  .tab {
    font-size: 1rem !important;
  }
}
</style>